import type { BulkFieldValue } from '../../../types'

export function computeEmail(
  orders: uui.domain.client.rm.ExtendedOrderStep[],
): BulkFieldValue<string> {
  const email = orders[0].orderStep.email
  const exact = orders.every(o => o.orderStep.email === email)

  if (exact) {
    return {
      status: 'exact',
      value: email ?? '',
    }
  }

  return {
    status: 'mixed',
  }
}
